import * as React from "react";
import { Component } from "react";
import MessageService from "../service/MessageService";

export interface ActionEvent {
  actionId: string;
  last: boolean;
  startAt: number;
  total: number;
  progress: number;
  failure: number;
  error?: string;
}

interface SSEButtonProp {
  start: () => Promise<ActionEvent> | void;
  onFinish?: (event: ActionEvent) => void;
  className?: string;
  disabled?: boolean;
}

interface SSEButtonState {
  progress?: ActionEvent;
}

export default class SSEButton extends Component<SSEButtonProp, SSEButtonState> {
  source: EventSource;

  constructor(prop: SSEButtonProp) {
    super(prop);

    this.state = { progress: null };
  }

  private onClickStart(evt: React.MouseEvent) {
    evt.preventDefault();
    evt.stopPropagation();

    this.setState({ progress: null });

    const startPromise = this.props.start();

    if (!startPromise || !startPromise.then) {
      return;
    }

    startPromise.then((progress) => {
      if (this.source) this.source.close();

      this.source = new EventSource("/api/events?actionId=" + progress.actionId);

      this.source.onmessage = (event) => {
        const actionEvent = JSON.parse(event.data) as ActionEvent;

        this.setState({ progress: actionEvent });

        if (actionEvent.last) {
          this.source.close();

          if (this.props.onFinish) {
            this.props.onFinish(actionEvent);
          }
        }
      };

      this.source.onerror = (e) => {
        this.source.close();
        console.error((e as MessageEvent).data);
        MessageService.error("Impossible de récupérer l'état de progression");
      };

      this.setState({ progress });
    });
  }

  render() {
    return (
      <button
        className={this.props.className || "btn btn-secondary"}
        onClick={(evt) => this.onClickStart(evt)}
        disabled={this.props.disabled || (this.state.progress !== null && !this.state.progress.last)}
      >
        {this.props.children}

        {this.state.progress && (
          <span>
            &nbsp;{this.state.progress.progress} / {this.state.progress.total}
          </span>
        )}
      </button>
    );
  }
}
